// components/ProfileDropdown.js
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase"; // Adjust path

const ProfileDropdown = ({ user }) => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLogout = async () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (confirmed) {
      await signOut(auth);
      navigate("/login");
    }
  };

  return (
    <Dropdown align="end">
      <Dropdown.Toggle variant="light" className="d-flex align-items-center">
        <FaUserCircle size={24} className="me-2" />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Header>
          {user?.username || user?.email?.split("@")[0]}
        </Dropdown.Header>

        {/* <Dropdown.Item
          onClick={() => {
            if (user?.role === "admin") {
              navigate("/admin");
            } elseif {
              navigate("/agent-dashboard");
            } else{

            }
          }}
        >
          Dashboard
        </Dropdown.Item> */}
        <Dropdown.Item
          onClick={() => {
            if (user?.role === "admin") {
              navigate("/admin");
            } else if (user?.role === "agent") {
              navigate("/agent-dashboard");
            } else {
              navigate("/user-dashboard");
            }
          }}
        >
          Dashboard
        </Dropdown.Item>

        <Dropdown.Item onClick={() => navigate("/settings")}>
          Profile Settings
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.Item onClick={handleLogout} className="text-danger">
          Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
